export const GET_REP_DASBOARD_END='getrepdashboard.end';
export const GET_REP_DASBOARD_BY_ID_END='getrepdashboardbyid.end';
export const SET_EDIT_DASBOARD='seteditdashboard'
export const CREATE_DASHBORD='createdashboard'